// extracted by mini-css-extract-plugin
module.exports = {"extraDarkColour":"#373737","backgroundColour":"#171C1F","container":"TabNav-module--container--3Y87n"};